export default class Checkout {
	/**
	 * Constructor
	 *
	 * @param {HTMLElement} element The root element for this component
	 */
	constructor( element ) {
		this.element = element;
	}

	/**
	 * Initialize the class with all logic / event listeners
	 */
	init() {
		jQuery( document ).ready( $ => {
			this.setupCouponCodeHandling( $ );
		} );

		// Note this event can run multiple times per page load (like every time you change shipping method for example).
		jQuery( document.body ).on( 'updated_checkout', () => {
			this.setupKlaviyoNewsletterIntegration();
			this.setupCartToggling();
		} );

		//I have separated the billing company toggle from the rest of the coupon logic
		//because we want to make sure that the billing company toggle is always available
		//even if the coupon code is not available.
		document.addEventListener( 'DOMContentLoaded', () => {
			this.setupBillingCompanyToggle();
		} );
	}

	/**
	 * Setup the billing company toggle. Add aria-expanded and event listeners for click keyboard.
	 *
	 * @return {void}
	 */
	setupBillingCompanyToggle() {
		const label = document.querySelector( '#billing_company_field > label' );
		const input = document.querySelector( '#billing_company' );

		if ( ! label || ! input ) {
			return;
		}

		// Add aria controls.
		input.setAttribute( 'aria-hidden', 'true' );
		label.setAttribute( 'role', 'button' );
		label.setAttribute( 'tabindex', '0' );
		label.setAttribute( 'aria-controls', 'billing_company' );
		label.setAttribute( 'aria-expanded', 'false' );
		label.setAttribute( 'aria-label', 'Toggle company name field' );

		/**
		 * Toggle visibility of the input and update ARIA state.
		 *
		 * @param {Event} [event] Click or keydown event.
		 * @return {void}
		 */
		const toggle = event => {
			if ( event ) {
				event.preventDefault();
			}

			const isLabelExpanded = label.getAttribute( 'aria-expanded' ) === 'true';
			const wasInputHidden = input.getAttribute( 'aria-hidden' ) === 'false';

			// Toggle states
			label.setAttribute( 'aria-expanded', isLabelExpanded ? 'false' : 'true' );
			input.setAttribute( 'aria-hidden', wasInputHidden ? 'true' : 'false' );
			input.style.display = wasInputHidden ? 'none' : 'block';

			if ( ! wasInputHidden ) {
				input.focus();
			}
		};

		label.addEventListener( 'click', toggle );

		label.addEventListener( 'keydown', e => {
			if ( e.key === 'Enter' || e.key === ' ' ) {
				e.preventDefault();
				toggle();
			}
		} );
	}

	/**
	 * Setup the coupon code handling.
	 *
	 * @param {jQuery} $ The jQuery object
	 * @return {void}
	 */
	setupCouponCodeHandling( $ ) {
		// we need this code for the custom coupon code placement in checkout
		if ( ! $( '.checkout-toggle-section' ).length ) {
			return;
		}

		// Cache DOM elements for reuse
		const $couponBtn = $( '.checkout-toggle-section.coupon-toggle' );
		const $couponForm = $( '#coupon_container' );
		const $couponCodeInput = $( '#coupon_code' );
		const $applyCouponBtn = $( '#apply_coupon_btn' );
		const nonce = window?.qalaThemeData?.applyCouponNonce;

		// Toggle coupon form visibility
		if ( $couponBtn.length > 0 ) {
			$couponBtn.on( 'click', function() {
				$couponForm.toggleClass( 'woocommerce-form-coupon--show' );
				$( this ).toggleClass( 'active' );
				if ( $( '.woocommerce-error' ).length ) {
					$( '.woocommerce-error' ).remove();
				}
			} );
		}

		// Prevent form submission when hitting Enter in the coupon code input.
		// Instead, lets trigger the coupon button.
		$couponCodeInput.on( 'keydown', function( event ) {
			if ( event.which === 13 ) {
				event.preventDefault();
				$applyCouponBtn.trigger( 'click' );
			}
		} );

		// Apply coupon using AJAX when clicking 'Apply coupon' button
		$applyCouponBtn.on( 'click', function( event ) {
			event.preventDefault();

			const couponCode = $couponCodeInput.val();

			// Show loading overlay
			$( 'body' ).block( {
				message: null,
				overlayCSS: {
					background: '#fff',
					opacity: 0.6,
				},
			} );

			const ajaxUrl = window?.wc_checkout_params?.ajax_url;

			// Make AJAX request to apply coupon
			$.ajax( {
				type: 'POST',
				url: ajaxUrl,
				data: {
					action: 'apply_coupon_code',
					coupon_code: couponCode,
					security: nonce,
				},
				success( response ) {
					if ( response.success ) {
						$( 'body' ).trigger( 'update_checkout' );
						$couponForm.removeClass( 'woocommerce-form-coupon--show' );
						$couponBtn.toggleClass( 'active' );
					} else {
						$( '#coupon_container' ).before(
							'<div class="woocommerce-error">' + response.data + '</div>'
						);
					}
				},
				complete() {
					$( 'body' ).unblock();
				},
			} );
		} );
	}

	/**
	 * Setup the Klaviyo checkbox / newsletter integration.
	 *
	 * @return {void}
	 */
	setupKlaviyoNewsletterIntegration() {
		const checkoutNewsletterCheckbox = document.getElementById( 'checkout-newsletter' );
		const klaviyoCheckbox = document.getElementById( 'kl_newsletter_checkbox' );

		if ( checkoutNewsletterCheckbox === null || klaviyoCheckbox === null ) {
			return;
		}

		if ( checkoutNewsletterCheckbox ) {
			// Note this event listener will get setup every time the checkout is updated (which can happen multiple
			// time per page load). This is not ideal but with the current code it doesn't really matter.
			checkoutNewsletterCheckbox.addEventListener( 'change', function() {
				if ( this.checked ) {
					klaviyoCheckbox.checked = true;
				} else {
					klaviyoCheckbox.checked = false;
				}
			} );
		}
	}

	/**
	 * Setup the cart toggling functionality.
	 *
	 * @return {void}
	 */
	setupCartToggling() {
		this.checkoutViewMore = document.querySelector( '.shop-table-view-more' );
		this.checkoutViewMoreBtn = document.getElementById( 'checkout-view-more' );
		this.checkoutTable = document.querySelector( '.shop_table--max-3-mobile' );

		if ( ! this.checkoutViewMore || ! this.checkoutTable || ! this.checkoutViewMoreBtn ) {
			return;
		}

		if ( this.checkoutViewMoreBtn ) {
			this.checkoutViewMoreBtn.removeAttribute( 'disabled' );

			// Remove the last iteration (so we don't get multiple event listeners, for every time the update_checkout event is triggered)
			if ( this.bindedCheckoutViewMoreHandler ) {
				this.checkoutViewMoreBtn.removeEventListener( 'click', this.bindedCheckoutViewMoreHandler );
			}

			this.bindedCheckoutViewMoreHandler = this.checkoutViewMoreHandler.bind( this );
			this.checkoutViewMoreBtn.addEventListener( 'click', this.bindedCheckoutViewMoreHandler );
		}
	}

	/**
	 * Checkout functionality.
	 *
	 * This file should be cleaned up, maybe changed from using jQuery everywhere too.
	 *
	 * @param {Event} event The event object
	 */
	checkoutViewMoreHandler( event ) {
		event.preventDefault();

		if ( ! this.checkoutTable ) {
			return;
		}

		this.checkoutTable.classList.toggle( 'shop_table--max-3-mobile-show' );
		if ( this.checkoutViewMoreBtn.innerHTML === this.checkoutViewMoreBtn.dataset.btnHideText ) {
			this.checkoutViewMoreBtn.innerHTML = this.checkoutViewMoreBtn.dataset.btnShowText;
			this.checkoutViewMoreBtn.setAttribute( 'aria-expanded', 'false' );
		} else {
			this.checkoutViewMoreBtn.innerHTML = this.checkoutViewMoreBtn.dataset.btnHideText;
			this.checkoutViewMoreBtn.setAttribute( 'aria-expanded', 'true' );
		}
		this.checkoutViewMoreBtn.blur();
	}
}
